const style = {
  list: {
    margin: 0,
    padding: `10px 0`,
    listStyle: `none`
  },
  listItem: {
    padding: `5px 15px`,
    paddingLeft: `0`,
    color: `#777779`,
    fontSize: `13px`
  },
  listItemLink: {
    color: `#A94545`
  },
  themeItem: {
    cursor: `pointer`
  },
  activeTheme: {
    color: `#777779`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Footer/style/bottom.js